import type { ModuleDefinition } from '@em-cms/core';

export const moduleConfig = {
  id: 'seo',
  name: 'SEO',
  description: 'بهینه‌سازی موتورهای جستجو و مدیریت سئو',
  version: '0.1.0',
  is_core: false,
  requires: [],
  tables: ['cms_seo_settings', 'cms_page_seo', 'cms_redirects'],
};

export const seoModule: ModuleDefinition = {
  id: 'seo',
  name: 'SEO',
  description: 'بهینه‌سازی موتورهای جستجو و مدیریت سئو',
  version: '0.1.0',
  icon: 'Globe',
  category: 'utility',
  dependencies: [],
  tables: ['cms_seo_settings', 'cms_page_seo', 'cms_redirects'],
  adminRoutes: [
    {
      path: '/seo',
      component: () => import('./admin/SeoSettingsPage').then(m => ({ default: m.SeoSettingsPage })),
      permission: 'seo.manage',
      label: 'تنظیمات SEO',
      icon: 'Globe',
    },
  ],
};
